// Tipos de documento - Colombia Salud (según PDF: CC, TI, RC, NUIP, CE)
export const TIPOS_IDENTIFICACIONES = [
  { value: "CC", text: "C.C. (Cédula de Ciudadanía)" },
  { value: "TI", text: "T.I. (Tarjeta de Identidad)" },
  { value: "RC", text: "RC (Registro Civil)" },
  { value: "NUIP", text: "NUIP (Nº único de Identificación Personal)" },
  { value: "CE", text: "C.E. (Cédula de Extranjería)" },
  { value: "OT", text: "Otro" },
];

// Procedimiento - Solicitud Individual Seguro Salud
export const TIPOS_PROCEDIMIENTO = [
  { value: "INCLUSION", text: "Inclusión" },
  { value: "MODIFICACION_ASEGURADOS", text: "Modificación Asegurados" },
  { value: "ACTUALIZACION_DATOS", text: "Actualización de Datos" },
];

// Parentesco - Relación de personas a asegurar (PDF)
export const PARENTESCO_SALUD = [
  { value: "AP", text: "Empleado" },
  { value: "CO", text: "Cónyuge" },
  { value: "HI", text: "Hijo(a)" },
  { value: "PR", text: "Progenitor" },
  { value: "HE", text: "Hermano(a)" },
  { value: "SO", text: "Sobrino(a)" },
  { value: "NI", text: "Nieto(a)" },
  { value: "SU", text: "Suegra/o" },
  { value: "OT", text: "Otro" },
];

export const TIPOS_SEXO = [
  { value: "M", text: "Masculino" },
  { value: "F", text: "Femenino" },
];

export const TIPOS_SINO = [
  { value: "S", text: "Sí" },
  { value: "N", text: "No" },
];

// Cuestionario médico de asegurabilidad (orden del formulario: code 1 a 24)
/* eslint-disable max-len */
export const PREGUNTAS_CUESTIONARIO_MEDICO = [
  { code: 1, label: "¿Enfermedades del oído, nariz, garganta o defectos de la vista?" },
  { code: 2, label: "¿Desmayos o mareos, convulsiones, dolores de cabeza severos, trastornos mentales o nerviosos, defecto al hablar, parálisis, embolia?" },
  { code: 3, label: "¿Asfixia, ronquera o catarro persistente, expectora sangre, tos crónica, trastornos respiratorios crónicos, bronquitis, asma, pleuresía, enfisema, tuberculosis?" },
  { code: 4, label: "¿Dolores de pecho, palpitaciones, presión arterial alta o baja, soplo en el corazón, o cualquier otro trastorno del corazón o vasos arteriales, venas varicosas?" },
  { code: 5, label: "¿Ictericia, hemorragia intestinal, úlcera, apendicitis, colitis, diverticulitis, hemorroides, indigestión recurrente, o cualquier otro trastorno del estómago, intestino, hígado o vesícula?" },
  { code: 6, label: "¿Azúcar, albúmina, sangre o pus en la orina, enfermedades venéreas, nefritis, cálculos o cualquier otro trastorno del riñón, vejiga, próstata, páncreas, hernias, trastorno urinario, del recto y órganos reproductivos?" },
  { code: 7, label: "¿Diabetes, tiroides u otro trastorno endocrinológico?" },
  { code: 8, label: "¿Neuritis, ciática, reumatismo, artritis, gota, fiebre reumática?" },
  { code: 9, label: "¿Deformación, cojera, amputación o menoscabo físico, trastornos de los músculos o huesos, lesiones óseas de la cabeza, espina dorsal?" },
  { code: 10, label: "¿Alergias, anemia o cualquier otro trastorno de la sangre?" },
  { code: 11, label: "¿Trastornos del sistema inmunológico?" },
  { code: 12, label: "¿Algún trastorno mental o físico que no haya sido mencionado anteriormente?" },
  { code: 13, label: "¿Trastornos de la piel, glándulas linfáticas, quistes, tumores o cáncer?" },
  { code: 14, label: "¿Padece alguna enfermedad o defecto congénito?" },
  { code: 15, label: "¿Ha consultado algún médico o le han recomendado hacerse algún examen para diagnóstico, hospitalización o cirugía que no haya sido realizado?" },
  { code: 16, label: "¿Le han efectuado un electrocardiograma, rayos X o cualquier otro examen para diagnóstico?" },
  { code: 17, label: "¿Ha estado alguna vez internado en un hospital, clínica, por razones de diagnóstico o tratamiento?" },
  { code: 18, label: "¿En algún momento ha solicitado o recibido beneficios o pagos de una pensión, debido a un accidente, enfermedad o incapacidad?" },
  { code: 19, label: "¿Se encuentra en estos momentos bajo la observación de un médico legalmente autorizado, tomando algún medicamento o recibiendo algún tratamiento por algún motivo?" },
  { code: 20, label: "¿Esta usando o ha usado alguna vez barbitúricos, anfetaminas, droga que produce alucinamientos, narcóticos o cualquier otra droga?" },
  { code: 21, label: "¿Ha recibido o necesita asesoramiento, consejo o tratamiento en relación al uso de drogas o alcohol?" },
  { code: 22, label: "Para mujeres únicamente: ¿Trastornos femeninos, órganos reproductivos, menstruación, embarazo o problemas de los senos?" },
  { code: 23, label: "Para mujeres únicamente: ¿Se encuentra actualmente embarazada? (o su cónyuge) si se encuentra, favor de indicar la fecha en que se espera el alumbramiento?" },
  { code: 24, label: "Para mujeres únicamente, detalle (embarazos, partos, abortos, cesáreas)" },
];
/* eslint-enable max-len */
